import * as types from './constants';

const initialState = {
  data: {
    faq: [],
    definitions: []
  },
  getLoading: false,
  errors_api: {}
};

const actions = {
  // Get Faq
  [types.GET_FAQ_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_FAQ_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: {
        ...state.data,
        faq: payload
      }
    };

    return { ...data };
  },

  [types.GET_FAQ_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Get Definitions
  [types.GET_DEFINITIONS_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_DEFINITIONS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: {
        ...state.data,
        definitions: payload
      }
    };

    return { ...data };
  },

  [types.GET_DEFINITIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};